const rotas = {
  login:          '/webgestor/api/login/login.php',
  senhaSolicitar: '/webgestor/api/login/solicitar/',
  senhaValidar:   '/webgestor/api/login/validar/',
  senhaRedefinir: '/webgestor/api/login/redefinir/',
  menu: '/webgestor/api/menu/menu.php',
  atendimento: '/webgestor/api/estatistica/atendimento/',
  atualizaPrecoMatrizNfe: '/webgestor/api/nfe/atualizaPrecoMatriz.php',
  beneficio: '/webgestor/api/cadastros/beneficios/',
  beneficioProduto: '/webgestor/api/cadastros/produtos/components/beneficios/index.php',
  buscaCadastro: '/webgestor/api/busca/cadastro.php',
  campanha: '/webgestor/api/campanhas/campanha/',
  campanhaPesquisaMassa: '/webgestor/api/campanhas/campanha/pesquisaProdutosMassa.php',
  campanhaInserirEmLote: '/webgestor/api/campanhas/campanha/inserirProdutosEmLote.php',
  caixa: '/webgestor/api/caixa/',
  caixaFpagtos: '/webgestor/api/caixaFpagtos/',
  caixaTotalizado: '/webgestor/api/caixaTotalizado/',
  categoria: '/webgestor/api/cadastros/categorias/',
  categoriaSelect: '/webgestor/api/cadastros/categorias/categoriaSelect.php',
  categoriaProduto: '/webgestor/api/cadastros/produtos/components/categorias/index.php',
  categoriaPedidos: '/webgestor/api/pedidos/assistente/components/categorias/',                    
  centralPrecos: '/webgestor/api/centralPrecos/',
  centroCusto: '/webgestor/api/centroCusto/',
  consultaCep: '/webgestor/api/cadastros/fornecedores/consultaCEP.php',
  classifTipo: '/webgestor/api/cadastros/classifTipo/',
  clientes: '/webgestor/api/cadastros/clientes/',
  curvaAbc: '/webgestor/api/estatistica/curvaAbc/',
  curvaAbcd: '/webgestor/api/estatistica/curvaAbcd/',
  comissao: '/webgestor/api/cadastros/comissoes/',
  contasApagar: '/webgestor/api/contas/apagar/',
  contasApagarEmMassa: '/webgestor/api/contas/apagar/pagarEmMassa.php',
  convenios: '/webgestor/api/cadastros/convenios/',
  convModeloDesconto: '/webgestor/api/cadastros/convenios/modeloDesconto/',
  configLojas: '/webgestor/api/configLojas',
  descontoConvenio: '/webgestor/api/convDesconto.php',
  desconto: '/webgestor/api/estatistica/desconto/',
  deletaTabloide : '/webgestor/api/tabloides/consulta/deletaTabloide.php',
  estabelecimento: '/webgestor/api/cadastros/estabelecimentos/',
  ecommerceTipoPreco: '/webgestor/api/precos/ecommerce/component/tipoPreco/',
  ecommercePrecificar: '/webgestor/api/precos/ecommerce/',
  ecommerceProdutos:'/webgestor/api/precos/ecommerce/produtos/',
  EstatisticaVendas: '/webgestor/api/estatistica/venda/',
  estatisticaProjecao: '/webgestor/api/estatistica/projecao/',
  estatisticaDelivery: '/webgestor/api/estatistica/delivery/',
  excluiNfePainel: '/webgestor/api/nfe/excluiNfePainel.php/',
  favorecido: '/webgestor/api/cadastros/favorecidos/',
  fabricantePedidos: '/webgestor/api/pedidos/assistente/components/fabricante/index.php',
  fornecedoresPedidos: '/webgestor/api/pedidos/assistente/components/fornecedores/index.php',
  fechaConvenio: '/webgestor/api/convenios/fechamento/',
  filtroClienteRelatorio: '/webgestor/api/relatorios/filtros/clientes.php',
  filtroProdutoRelatorio: '/webgestor/api/relatorios/filtros/produtos.php',
  filtroLojasRelatorio:'/webgestor/api/relatorios/filtros/lojas.php',
  fornecedor: '/webgestor/api/cadastros/fornecedores/',
  fornecedorProduto: '/webgestor/api/cadastros/produtos/components/fornecedores/index.php',
  fornecedorNfe: '/webgestor/api/nfe/verificaFornecedor.php',
  gravarConvenios: '/webgestor/api/cadastros/convenios/gravar.php',
  gravarDescontoConvenios:'/webgestor/api/cadastros/convenios/descontos/gravar.php',
  gravarEscalonado:'/webgestor/api/cadastros/produtos/gravaEscalonado.php',
  gravaNota:'/webgestor/api/nfe/gravaNota.php',
  gravaSubstanciaProduto:'/webgestor/api/cadastros/produtos/gravaNovaSubstancia.php',
  gravaProdutoRelacionado:'/webgestor/api/cadastros/produtos/gravaNovoProdutoRelacionado.php',
  gravaProduto:'/webgestor/api/cadastros/produtos/gravaProduto.php',
  grupoCompras: '/webgestor/api/cadastros/grupoCompras/',
  grupoComprasProduto: '/webgestor/api/cadastros/produtos/components/grupoCompras/index.php',
  grupoComprasPedido: '/webgestor/api/pedidos/assistente/components/grupoCompras/index.php',
  // listaPsicotropicos: '/webgestor/api/listaPsicotropicos.php',
  lista: '/webgestor/api/cadastros/lista/',
  listarEstoqueOL: '/webgestor/api/cadastros/produtos/listarEstoqueOL.php',
  listarEscalonado: '/webgestor/api/cadastros/produtos/listarEscalonado.php',
  listarDestinatario: '/webgestor/api/nfe/listarDestinatario.php',  
  listarProdutosNfe: '/webgestor/api/nfe/listarProdutosNfe.php',
  listarProdutosRelacionados: '/webgestor/api/cadastros/produtos/listarProdutosRelacionados.php',
  listarRelatorios: '/webgestor/api/relatorios/listarRelatorios.php',
  relatorioFavoritos: '/webgestor/api/relatorios/favoritos.php',
  listarSubstanciasProduto: '/webgestor/api/cadastros/produtos/listarSubstancias.php',
  listarLotesProdutos: '/webgestor/api/cadastros/produtos/listarLotes.php',
  listarDetalhesPromocao: '/webgestor/api/cadastros/produtos/listarDetalhesPromocao.php',
  listarLojasTabloide: '/webgestor/api/tabloides/consulta/lojasTabloide.php', 
  listarTabloides: '/webgestor/api/tabloides/consulta/listarTabloides.php',
  listarUnidadeMedida: '/webgestor/api/cadastros/produtos/listaUnidadeMedida.php',
  lojas: '/webgestor/api/cadastros/lojas/',
  lojasSelect: '/webgestor/api/lojasSelect.php',
  lojasTabloide: '/webgestor/api/tabloides/consulta/lojasTabloide.php',
  lojasPrecificador: '/webgestor/api/fidelidade/precificador/lojas/index.php',
  lucro: '/webgestor/api/estatistica/lucro/',
  nfeCpag: '/webgestor/api/nfe/nfeCpag/',
  nfeDownload:  '/webgestor/api/nfe/dfe/download/',
  nfeDfeConfig: '/webgestor/api/nfe/dfe/config/',
  notificacoes: '/webgestor/api/notificacoes/',
  Kit: '/webgestor/api/campanhas/kit/',
  pedidos: '/webgestor/api/pedidos/assistente/',
  pedidoAtualizaQuantidade: '/webgestor/api/pedidos/assistente/quantidade/',
  pedidoConfig: '/webgestor/api/pedidos/assistente/config/',
  pedidoCentralCotacoes: '/webgestor/api/pedidos/assistente/cotacao/centralCotacao/',
  pedidoCoteSimples: '/webgestor/api/pedidos/assistente/cotacao/coteSimples/',
  pedidoSmartGruppy: '/webgestor/api/pedidos/assistente/cotacao/smartGruppy/',
  pedidoCoteFacil: '/webgestor/api/pedidos/assistente/cotacao/cotefacil/',
  pedidoImprimir: '/webgestor/api/pedidos/assistente/impressao/pedido/',
  pedidoExcel: '/webgestor/api/pedidos/assistente/excel/',
  pedidoSic: '/webgestor/api/pedidos/assistente/cotacao/sic/',
  pedidoCotacaoDigifarma: '/webgestor/api/pedidos/assistente/cotacao/digifarma/',
  pedidoSmartPed: '/webgestor/api/pedidos/assistente/cotacao/smartped/',
  pedidoSmartPedImprimir: '/webgestor/api/pedidos/assistente/impressao/smartped/',
  pedidoFaltas: '/webgestor/api/pedidos/assistente/faltas/',
  pedidoMovimentacao: '/webgestor/api/pedidos/assistente/movimentacao/',
  pedidoSessoes: '/webgestor/api/pedidos/assistente/sessoes/',
  pedidoProdutos: '/webgestor/api/pedidos/assistente/components/produtos/',
  pedidoIncluirProduto: '/webgestor/api/pedidos/assistente/incluir/',
  pedidoRemessa: '/webgestor/api/pedidos/assistente/remessa/',
  perfil: '/webgestor/api/perfil/',
  perfil_cad: '/webgestor/api/cadastros/perfis/',
  perfil_controleItem: '/webgestor/api/perfil_controleItem/',
  planoContas: '/webgestor/api/cadastros/planoContas/',
  precificar: '/webgestor/api/fidelidade/precificador/precificar.php',
  precificacaoColunas: '/webgestor/api/fidelidade/precificador/colunas/index.php', 
  precificacaoHistorico: '/webgestor/api/fidelidade/precificador/historico/index.php',
  precificacaoHistoricoProdutos: '/webgestor/api/fidelidade/precificador/historico/produtos/index.php',
  premio: '/webgestor/api/cadastros/premios/',
  produto: '/webgestor/api/cadastros/produtos/',
  produtos: '/webgestor/api/cadastros/produtos/listar.php',
  produtosTabloide: '/webgestor/api/tabloides/cadastro/produtosTabloide.php',
  produtosPrecificador: '/webgestor/api/fidelidade/precificador/listar.php',
  removeEscalonado: '/webgestor/api/cadastros/produtos/removeEscalonado.php',
  removeSubstanciaProduto: '/webgestor/api/cadastros/produtos/removeSubstanciaProduto.php',
  removeProdutoRelacionado: '/webgestor/api/cadastros/produtos/removeProdutoRelacionado.php',
  statusNfe: '/webgestor/api/nfe/statusNfe.php',
  subcategoria: '/webgestor/api/cadastros/subCategorias/',
  subcategoriaProduto: '/webgestor/api/cadastros/produtos/components/subcategorias/index.php',
  subcategoriaPedidos: '/webgestor/api/pedidos/assistente/components/subcategorias/index.php',
  substancia: '/webgestor/api/cadastros/substancias/',
  substanciaPedidos: '/webgestor/api/pedidos/assistente/components/substancias/index.php',
  tabloideCadastro: '/webgestor/api/tabloides/cadastro/',
  tributacao: '/webgestor/api/cadastros/tributacoes/',
  usuarios: '/webgestor/api/cadastros/usuarios/',
  ultCompras: '/webgestor/api/cadastros/produtos/listarUltCompras.php',
  uploadTabloide: '/webgestor/api/tabloides/cadastro/excelTabloide.php',
  vendedor: '/webgestor/api/cadastros/vendedores/',
  vendas: '/webgestor/api/vendas/',
  vendasTotal: '/webgestor/api/vendas/totalQuantidade.php',
  vendasGrafico: '/webgestor/api/vendas/principalGrafico.php',
  verificaCodBarras: '/webgestor/api/cadastros/produtos/verificaCodBarras.php'
}

export default rotas
